
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[seoName]",
      function () {
        return require("private-next-pages/[seoName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[seoName]"])
      });
    }
  